import React, { useEffect, useState } from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// utils
import { getAllQueryParams } from '../../../../utils/getNmTalentCareersLinks/getNmTalentCareersLinks';

export default ({ careersFormLink }) => {
  const [queryParams, setQueryParams] = useState(false);

  useEffect(() => {
    const res = getAllQueryParams();
    setQueryParams(res);
  }, []);

  return (
    <SectionContainer
      id='recruitment-campaign-advisor-connect-generic'
      backgroundVariant='darkDefault'
      themeType='darkTheme'>
      <Row align='center'>
        <Col
          medium={8}
          align='center'>
          <Typography
            component='h2'
            themeType='darkTheme'
            nextElement='button'>
            Discover the career you never knew you <WidowBlock>always wanted.</WidowBlock>
          </Typography>
          <Link
            id='recruitment-campaign-advisor-connect-generic-link'
            variant='buttonLinkPrimary'
            themeType='darkTheme'
            linkUrl={careersFormLink + queryParams}
            ariaLabel='Apply for a career with Northwestern Mutual today'>
            Apply today
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );
};
